import { render, staticRenderFns } from "./Longevidad.vue?vue&type=template&id=eeb1034a&scoped=true&"
import script from "./Longevidad.vue?vue&type=script&lang=js&"
export * from "./Longevidad.vue?vue&type=script&lang=js&"
import style0 from "./Longevidad.vue?vue&type=style&index=0&id=eeb1034a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb1034a",
  null
  
)

export default component.exports